
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselInDistress as ObiVesselInDistressElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-in-distress.js';
 
 
 

 
 export const ObiVesselInDistress = createComponent({
   react: React,
   tagName: 'obi-vessel-in-distress',
   elementClass: ObiVesselInDistressElement,
   events: {
     
   }
  });
 
 